import useSessionStorage from '@/hooks/use-session-storage';
import {
  FROM_MOBILE_INBOX_SESSION_STORAGE_KEY,
  INBOX_SESSION_STORAGE_KEY,
} from '@/lib/constants';
import { createContext, useContext } from 'react';

type InboxContextType = {
  isInboxView: boolean;
  setIsInboxView: (isInboxView: boolean) => void;
  isFromMobileInbox: boolean;
  setIsFromMobileInbox: (isFromMobileInbox: boolean) => void;
};

const DefaultInboxContext: InboxContextType = {
  isInboxView: false,
  setIsInboxView: () => {},
  isFromMobileInbox: false,
  setIsFromMobileInbox: () => {},
};

const InboxContext = createContext<InboxContextType>(DefaultInboxContext);

export const useInboxContext = () => {
  const context = useContext(InboxContext);
  if (!context) {
    throw new Error('useInboxContext must be used within a InboxProvider');
  }
  return context;
};

export const InboxProvider = ({ children }: { children: React.ReactNode }) => {
  const [isInboxView, setIsInboxView] = useSessionStorage(
    INBOX_SESSION_STORAGE_KEY,
    false,
  );

  // Need to use this to show the navigate-back button ONLY when navigating to a deal page from the mobile inbox view
  const [isFromMobileInbox, setIsFromMobileInbox] = useSessionStorage(
    FROM_MOBILE_INBOX_SESSION_STORAGE_KEY,
    false,
  );

  return (
    <InboxContext.Provider
      value={{
        isInboxView,
        setIsInboxView,
        isFromMobileInbox,
        setIsFromMobileInbox,
      }}
    >
      {children}
    </InboxContext.Provider>
  );
};
